import { getRequest } from '@/core';
import { references } from '@/requests';

export default async function getReferencesRequest() {
	let url = references.getPath();
	try {
		let response = await getRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}